module.exports = __webpack_public_path__ + "videos/mts-products-comdi.bea5e68.webm";